/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import * as stores from "stores";
import { getPageZoomLevel } from "selectors/zoom";
import { getTotalPages } from "selectors/documentSelectors";
import { getPageTransformMatrix, getViewRotationMatrix } from "selectors/pageSelectors";

export const commonCodeApis = {
  getPageZoomLevel: pageIndex => getPageZoomLevel(stores, pageIndex),
  getNumPages: () => getTotalPages(stores),
  getPageTransformMatrix: (pageIndex, options) => getPageTransformMatrix(stores, pageIndex, options),
  getViewRotationMatrix: (pageIndex, rotationAngle) => getViewRotationMatrix(stores, pageIndex, rotationAngle)
};
